export const getFromStorage = (path: String) => {
  return `${ process.env.REACT_APP_AZURE_STORAGE_URL ?? '' }${ path }`;
}
